<h1 class="mat-h1" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{ title }}
</h1>
<mat-dialog-content>
For test only
</mat-dialog-content>
<mat-dialog-actions class="row">
  <button (click)="onCancel()" class="col btn-cancel" mat-raised-button>
    {{ cancelText }}
  </button>
  <button (click)="onSubmit()" class="col btn-submit"
          mat-raised-button>
    {{ submitText }}
  </button>
</mat-dialog-actions>
